import { useMemo } from 'react';
import { useAuth } from './AuthProvider';
import type { Permission } from './permissions';

export interface PermissionsApi {
  readonly has: (p: Permission) => boolean;
  readonly hasAll: (perms: readonly Permission[]) => boolean;
  readonly hasAny: (perms: readonly Permission[]) => boolean;
  readonly all: readonly Permission[];
}

export function usePermissions(): PermissionsApi {
  const { user, hasPermission } = useAuth();
  return useMemo<PermissionsApi>(
    () => ({
      has: hasPermission,
      hasAll: (perms) => perms.every(hasPermission),
      hasAny: (perms) => perms.some(hasPermission),
      all: user?.permissions ?? [],
    }),
    [user, hasPermission],
  );
}
